import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): FileSyncState => {
  return {
    syncingFiles: false,
    syncFilesProgress: {
      totalFileCount: 0,
      sizeOfFilesDownloaded: 0,
      numberOfFilesDownloaded: 0,
    },
    syncFilesError: null,
  };
};

const fileSync = (
  state = getInitialState(),
  action: ActionTypes
): FileSyncState => {
  switch (action.type) {
    case TypeKeys.SYNC_FILES_STARTED: {
      return {
        ...state,
        syncFilesProgress: {
          totalFileCount: 0,
          sizeOfFilesDownloaded: 0,
          numberOfFilesDownloaded: 0,
        },
        syncingFiles: true,
      };
    }
    case TypeKeys.SYNC_FILES_STATUS: {
      return {
        ...state,
        syncFilesProgress: action.downloadProgress,
      };
    }
    case TypeKeys.SYNC_FILES_ERROR: {
      return {
        ...state,
        syncFilesError: action.error,
      };
    }
    case TypeKeys.SYNC_FILES_COMPLETED: {
      return {
        ...state,
        syncingFiles: false,
      };
    }
  }
  return state;
};

export default fileSync;
